import React, {useState, useContext, useEffect} from 'react';

import {  
  Card,  
  Row,
  Col,
  Alert, ProgressBar
} from 'react-bootstrap';

import axios from 'axios';
import Utils from '../../Utils';

const StepLibrary = (props) => {

    const [loading, setLoading] = useState(true);
    const [lib ,setLib] = useState([]);
    
    const fetchLibrary = () => {

        setLoading('Fetching library.. please wait..');

        axios.get(Utils.apiUrl('library/list'),Utils.apiHeaders()).then(res => {    
            setLoading(false);
            setLib(res.data.data);
        }).catch(err => {
            window.alert(JSON.stringify(err)); 
        });        
    };

    useEffect(fetchLibrary,[]);

    const renderInfo = () => {
        return <Card className="card-box w-100 custempage">
        <Card.Body className="p-5">        
            <h5 className="mt-0 mb-3">
                <div className="my-1">Deploy a course from our free, editable library in one click.</div>
                <div className="my-1">Why pay for expensive training library subscriptions?</div>
                <div className="my-1">Simply edit any of our free courses to make it relevant and branded to your business.</div>
            </h5>
            {loading && <div className="text-center"><Alert> {loading}<br /><ProgressBar className="mt-2" animated variant="warning" now={100} /></Alert></div>}
            {!loading && lib.length > 0 && renderListing()}
            {!loading && lib.length === 0 && <div className="text-center p-2 m-2"><Alert variant="warning">No Records found</Alert></div>}



        </Card.Body>  
        </Card>
    }

    const chooseLibrary = (lib_id) => (e) => {
        window.location.href=`${process.env.PUBLIC_URL}/builder/lib/${lib_id}`;
    };
  
    const renderListing = () => {
        return <>
        <div className="cusTempListWrap popcotentpad">
          
          <Row>
            {lib.length === 0 && <Col sm={12}><Alert variant="info" className="m-2 text-center p-2">No Templates available!</Alert></Col>}
            {lib.length > 0 && <>
                {lib.map(l => <Col sm={3} key={l.id} className="py-2 text-center">
                    <Card className="m-2 template-slide h-100" onClick={chooseLibrary(l.id)}>
                        <Card.Body className="p-1">
                        <img src={`${process.env.PUBLIC_URL}/images/library/${l.thumb}`} className="img-fluid" alt=""/>
                        <div className="py-2">{l.name}</div>
                        </Card.Body>
                    </Card>
                </Col>)}
            </>}
          </Row>
          </div>
        </>;
      }
  
    return <Row>
        <Col className="mt-3 mb-5">{renderInfo()}</Col>    
    </Row>;
}

export default StepLibrary;